import React from "react";
import { Permissions } from "../../../../../util/Permissions";

const PermissionOptions = ({permissions}) => {

    // Check Read Permission checkbox for other permission type
    const checkReadBox = e => {
        const permissionName = e.currentTarget.name?.match(/(.*?)\[/)[1];
        document.querySelector(`input[name="${permissionName}[read]"]`).checked = true;
    }

    // UnCheck other Permission checkbox when read is unchecked
    const unCheckOtherBox = e => {
        if (!e.currentTarget.checked){
            const permissionName = e.currentTarget.name?.match(/(.*?)\[/)[1];
            document.querySelectorAll(`input[name^="${permissionName}"]`).forEach(el => el.checked = false);
        }
    }

    return <table className="table table-borderless my-3">
            <thead>
                <tr className="h6" >
                    <td className="h5">Permissions</td>
                    <td>
                        Create
                    </td>
                    <td>
                        Read
                    </td>
                    <td>
                        Update
                    </td>
                    <td>
                        Delete
                    </td>
                </tr>
            </thead>
            <tbody>
                {Object.entries(Permissions).map(arr => arr[1]).map((perm, i) => <tr key={`perm-${i}`} className="mt-3">
                    <td>{perm.title}</td>
                    <td className="text-center">
                        <input 
                            type="checkbox" 
                            defaultChecked={permissions && permissions[perm.name] && !!permissions[perm.name]?.create}
                            value={true}
                            name={`${perm.name}[create]`} 
                            className="form-check-input"
                            onChange={checkReadBox}
                        />
                    </td>
                    <td className="text-center">
                        <input 
                            type="checkbox" 
                            defaultChecked={permissions && permissions[perm.name] && !!permissions[perm.name]?.read}
                            value={true}
                            name={`${perm.name}[read]`} 
                            className="form-check-input"
                            onChange={unCheckOtherBox}
                        />
                    </td>
                    <td className="text-center">
                        <input 
                            type="checkbox"  
                            defaultChecked={permissions && permissions[perm.name] && !!permissions[perm.name]?.update}
                            value={true}
                            name={`${perm.name}[update]`}
                            className="form-check-input"
                            onChange={checkReadBox}
                        />
                    </td>
                    <td className="text-center">
                        <input 
                            type="checkbox" 
                            defaultChecked={permissions && permissions[perm.name] && !!permissions[perm.name]?.delete}
                            value={true}
                            name={`${perm.name}[delete]`}
                            className="form-check-input"
                            onChange={checkReadBox}
                        />
                    </td>
                </tr>)}
            </tbody>
        </table>
}


export default PermissionOptions